module.exports = __webpack_public_path__ + "img/raf-main-not-eligible.1a0d423.svg";